'use es6';

import { ID, TIMESTAMP } from '../constants/keyPaths';
import getIn from 'transmute/getIn';
export const getId = getIn(ID);
export const getTimestamp = getIn(TIMESTAMP);